import React, { useState } from 'react';
import Navbar from '../../components/navbar';
import Content1 from '../../components/content1';
import Content2 from '../../components/content2';
import Footer from '../../components/footer';
import FullWidthTabs from "../../components/tab"

export default function LandingPage() {
  const img = <img src={"/img/iklan2.png"} className="iklan2" alt="" />
  const mB = <a href="/sellerLogin" className="navbar-top">Mulai Berjualan  |</a>

  const logReg =
    <div className=' ms-auto'>
      <button className="navbar-top bg-transparent border-0" data-bs-toggle="modal" data-bs-target="#exampleModal">Daftar | Log In</button>
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered mb-5">
          <div className="modal-content logReg pb-5 mb-5">
            <div className="modal-header border-0">
              <button type="button" className="btn-close me-4 mt-2" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body mb-0 mb-md-3">
              <div className=" row p-0 m">
                <div className=" col border-end">
                  <FullWidthTabs />
                </div>
                <div className=" col">
                  <div className="">
                    <img alt="" src="/img/largeLogo.png" className="largeLogo ms-auto me-auto d-block mb-4" />
                    <p className="descLogo">Tempat Belanja Fashion No. 1 di Indonesia</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  const [Data, setData] = useState([])

  return (
    <>
      <Navbar mb={mB} logReg={logReg} userData={setData} />
      <Content1 item2={img} />
      <Content2></Content2>
      <Footer />
    </>
  );
}
